// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__255HE","badges":"styles_badges__JFEct"};